<!--
  Full view of the provision type object. One shared component per active navItem — the same shape
  as cp-provision-agent-full.component.html (PAT §L.2).

  The plain child lists share ONE component driven by the CpConfigChildTab descriptor from the base
  class. Seven navItems need more than that:
    contractEvents       — two-level (Provisionsereignis -> Preisgründe, K-15 -> K-16)
    matrices             — two-level (Provisionsmatrix -> Matrixzeilen, K-08 -> K-09)
    conditionSets        — two-level (Bedingungssatz -> Bedingungen); the jump target of the
                           condition preview of the six assignment tables (jumpToConditionSet)
    matrixAssignments    — the same child table, wrapped in the Provisionsart pre-filter (04 §6)
    componentEligibility — the same child table, wrapped in the Provisionsart pre-filter plus the
                           evaluation legend BR-1/BR-2/§12.7 (K-18)
    calculatedAgents     — the same child table, wrapped in the Zielkomponente pre-filter (K-17)
    configCheck          — the per-provision-type check report, not an entity list

  Only the active navItem is rendered, so exactly one child query fires per view (CONFIG-022).
-->
@if (navigationItems && initialized) {

    <div class="cp-provision-type-full mt-4">

        @if (activeNavigationItem?.action == 'baseData') {
            <cp-provision-type-base-data
                    [provisionTypeId]="objectIdentifier.objectId">
            </cp-provision-type-base-data>
        } @else if (activeNavigationItem?.action == 'contractEvents') {
            <cp-provision-type-contract-event
                    [provisionTypeId]="objectIdentifier.objectId">
            </cp-provision-type-contract-event>
        } @else if (activeNavigationItem?.action == 'matrices') {
            <cp-provision-type-matrix
                    [provisionTypeId]="objectIdentifier.objectId">
            </cp-provision-type-matrix>
        } @else if (activeNavigationItem?.action == 'conditionSets') {
            <cp-provision-type-condition-set
                    [provisionTypeId]="objectIdentifier.objectId"
                    [focusConditionSetId]="focusConditionSetId"
                    (onFocusConditionSetConsumed)="onFocusConditionSetConsumed()">
            </cp-provision-type-condition-set>
        } @else if (activeNavigationItem?.action == 'matrixAssignments') {
            <cp-provision-type-matrix-assignment
                    [provisionTypeId]="objectIdentifier.objectId"
                    [child]="childTabs['matrixAssignments']"
                    (onJumpToConditionSet)="jumpToConditionSet($event)">
            </cp-provision-type-matrix-assignment>
        } @else if (activeNavigationItem?.action == 'componentEligibility') {
            <cp-provision-type-component-eligibility
                    [provisionTypeId]="objectIdentifier.objectId"
                    [child]="childTabs['componentEligibility']"
                    (onJumpToConditionSet)="jumpToConditionSet($event)">
            </cp-provision-type-component-eligibility>
        } @else if (activeNavigationItem?.action == 'calculatedAgents') {
            <cp-provision-type-calculated-agent
                    [provisionTypeId]="objectIdentifier.objectId"
                    [child]="childTabs['calculatedAgents']"
                    (onJumpToConditionSet)="jumpToConditionSet($event)">
            </cp-provision-type-calculated-agent>
        } @else if (activeNavigationItem?.action == 'configCheck') {
            <cp-config-check-panel
                    [provisionTypeId]="objectIdentifier.objectId">
            </cp-config-check-panel>
        } @else if (childTabs[activeNavigationItem?.action]) {
            <cp-provision-type-child-table
                    [provisionTypeId]="objectIdentifier.objectId"
                    [child]="childTabs[activeNavigationItem.action]"
                    (onJumpToConditionSet)="jumpToConditionSet($event)">
            </cp-provision-type-child-table>
        }

    </div>

}
